const { createContext, useState } = require('react');

export const AlertContext = createContext({
  alertType: null,
  alertHeader: null,
  alertDescription: null,
  displayAlert: () => {},
  resetAlert: () => {},
});

export const AlertProvider = ({ children }) => {
  const [alertType, setAlertType] = useState(null);
  const [alertHeader, setAlertHeader] = useState(null);
  const [alertDescription, setAlertDescription] = useState(null);

  const displayAlert = (alertType, alertHeader, alertDescription) => {
    setAlertType(alertType);
    setAlertHeader(alertHeader);
    setAlertDescription(alertDescription);
  };

  const resetAlert = () => {
    setAlertType(null);
    setAlertHeader(null);
    setAlertDescription(null);
  };

  const value = {
    alertType,
    alertHeader,
    alertDescription,
    displayAlert,
    resetAlert,
  };
  return (
    <AlertContext.Provider value={value}>{children}</AlertContext.Provider>
  );
};
